<template>
  <div id="msg" ref="msg">
    <div>
      <a id="readAll" @click="read(alarms, 1)" st>
        批量阅读
      </a>
    </div>
    <div id="msg_list">
      <List class="row" v-for="(item, index) in alarms" :key="index">
        <template slot="title">
          <Tag color="red" style="margin: -4px 0 0 2px">{{
                    item.info
                  }}</Tag>
          {{ item.carNo }}
        </template>
        <template slot="day">
          <time-o :time="item.startTime" />
        </template>
      </List>
    </div>
    <div id="page">
      <Page
        :total="total"
        :page-size="pageSize"
        :current="pageNumber"
        @on-change="getAlarm"
        style="margin: 0 15px"
      />
    </div>
  </div>
</template>
<script>
import axios from "axios";
import timeO from "../common/time.vue";
var readList = [];
export default {
  components: { timeO },
  data() {
    return {
      sound: true, //提示音
      window: true, //报警弹窗
      isRead: "noRead",
      show: false,
      alarmTypeList: [],
      alarms: [],
      pageNumber: 1, //当前页
      pageSize: 50, //每页条数
      total: 0,
    };
  },
  computed: {
    isAlarm() {
      return this.$store.state.isAlarm;
    },
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
    //获取用户名
    getAlarm(pageNumber) {
      let params = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
      };
      axios({
        method: "post",
        url: axios.serverWeb + "/alarmInfo/push",
        data: params,
      }).then((res) => {
        var data = res.data.data.dataList;
        this.total = res.data.data.total;
        this.$emit("alrmTotal", this.total);
        var data = res.data.data.dataList;
        this.total = res.data.data.total;
        for (const i in data) {
          data[i].show = false;
        }
        this.alarms = data;
        this.$emit("alarms", this.alarms);
      });
    },
    read(item, way) {
      readList = [];
      if (way == 0) {
        readList.push(item.alarmInfoId);
        doread();
      }
      if (way == 1) {
        for (const i in item) {
          readList.push(item[i].alarmInfoId);
        }
        doread();
      }
      var that = this;
      function doread() {
        var params = new URLSearchParams();
        params.append("alarmInfoIdList", readList);
        params.append("status", 1);
        axios({
          method: "post",
          url: "/alarmInfo/updateAlarmStatus",
          data: params,
        }).then((res) => {
          that.getAlarm(1);
          that.$Message.success("阅读成功");
        });
      }
    },
    dass() {
      this.$store.state.menu.pathChange = !this.$store.state.menu.pathChange;
    },
  },
  mounted() {
    this.getAlarm(1);
  },
  watch: {
    //监控vebsock是否来新数据
    isAlarm(v) {
      this.getAlarm(1);
    },
  },
};
</script>
<style lang="">
#msg {
  width: 100%;
  background: #fff;
}

#msg #msg_list {
  width: 92%;
  background: #f5f5f5;
  margin: 4px 0 20px 0;
  position: absolute;
  top: 50px;
  bottom: 50px;
  overflow: auto;
}

#msg #readAll {
  color: #333;
  cursor: pointer;float: right;
}
#msg h2 {
  margin-top: 2px;
  color: #666;
}
#msg p {
  line-height: 1;
  color: #999;
}
#page {
  position: absolute;
  bottom: 20px;
  left: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/remind/noRead.vue